import { parseReferenceViewID } from './parseReferenceViewID.ts';
import { ReferenceViewID } from './types.ts';

export function isIDSubject(id: ReferenceViewID): boolean {
  const parsed = parseReferenceViewID(id);
  return 'type' in parsed && parsed.type === 'subject';
}
